import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store } from './core/stores';
import General from './components/wrappers/general';
import './core/styles/main.scss';

interface Props { wallId:string; eventName:string|boolean;}

class App extends Component<Props> {
  public render(){    
    const {wallId, eventName} = this.props;
    return(
      <Provider store={store}>
        <General wallId={wallId} eventName={eventName}/>
      </Provider>
    );
  }
}

/** APP SETUP */
const appelement = document.getElementById('app-wall-container') as HTMLElement;
const wallId = appelement.getAttribute('wallId') || false;
const eventName = appelement.getAttribute('event-name') || false;
if(wallId) {
  ReactDOM.render(
      <App wallId={wallId} eventName={eventName}/>,
    appelement
  );
  
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
} else {
  console.log(`Wall will not mount, wrong app instanciation: app element: ${(appelement)} wall id: ${wallId}`);
}

